import React, { useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { TextField } from '@mui/material';
import STATE from '../DATA_SET/IndianStates.json';
import COUNTRY_LIST from '../DATA_SET/countries.json';

const COUNTRY_OPTIONS = [...COUNTRY_LIST]
    .map((country) => country.name)
    .sort((a, b) => a.localeCompare(b));

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

// address_line_1: "Flat No. 102, Block B",
//     address_line_2: "Not requre",
//         city: "Mumbai",
//             state: "Mumbai",
//                 country_name: "India",
//                     pin: ""

const AddressForm = ({ address, isDefence, onChange }) => {
    const [SET_STATE, setSET_STATE] = React.useState(-1);
    const [ADDRESS_DETAILS, setADDRESS_DETAILS] = React.useState({
        "contact_no": "",
        "email": "",
        "address_line": "",
        "city": "",
        "state": "",
        "country": "India",
        "zip_code": "",
        "is_defence": 'No Defence Id',
        "person": {
            "type": 1,
            "name": "Indian Army",
        }
    });
    const [errors, setErrors] = React.useState({
        email: '',
        contact_no: ''
    });

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            return 'Email is required';
        }
        if (!emailRegex.test(email)) {
            return 'Please enter a valid email address';
        }
        return '';
    };

    // Phone number validation function
    const validatePhoneNumber = (phone) => {
        const phoneRegex = /^[0-9]{10}$/;
        if (!phone) {
            return 'Phone number is required';
        }
        if (!/^\d+$/.test(phone)) {
            return 'Phone number should contain only digits';
        }
        if (!phoneRegex.test(phone)) {
            return 'Phone number must be 10 digits';
        }
        return '';
    };




    useEffect(() => {
        console.log(address)
    }, [address]);

    const StateHandleChange = (event) => {
        console.log('please ---', event.target.value)
        setSET_STATE(event.target.value);
        onChange({
            ...address,
            state: STATE[event.target.value].name
        })
        // if (event.target.value !== -1) {

        //     setADDRESS_DETAILS({ ...ADDRESS_DETAILS, state: STATE[event.target.value].name });

        // } else {
        //     console.log('please select one')
        //     setADDRESS_DETAILS({ ...ADDRESS_DETAILS, state: STATE[event.target.value].name });

        // }
    };

    useEffect(() => {
        setADDRESS_DETAILS({
            "contact_no": address?.contact_no,
            "email": address?.email,
            "address_line": address?.address_line,
            "city": address?.city,
            "state": address?.state,
            "country": address?.country,
            "zip_code": address?.zip_code,
            "defence_id": address?.defence_id,

        });
        setSET_STATE(STATE.findIndex(obj => obj.name === address?.state))
    });

    // useEffect(() => {
    //     onChange(ADDRESS_DETAILS)
    // }, [ADDRESS_DETAILS, SET_STATE])
    return (
        <div>
            <div>
                <div className="Layer_Box_Two "  >
                    <div className="box form_box_common mb-3">
                        <h4>Contact Info</h4>
                        <p>We require a valid email address to contact you with the details of your booking.</p>
                        <p>
                            Please fill all mandatory fields (*).
                        </p>
                        <hr />
                        <ThemeProvider theme={darkTheme}>
                            <div className="row">
                                {isDefence &&
                                    <div className="col-md-12 mb-3">
                                        <FormControl fullWidth>
                                            <div className='label' >Defence ID *</div>
                                            <TextField
                                                InputProps={{ sx: { height: '3rem' } }}
                                                value={address?.defence_id}
                                                variant="outlined" onChange={(e) => {
                                                    onChange({
                                                        ...address,
                                                        defence_id: e.target.value
                                                    })
                                                    //setADDRESS_DETAILS({ ...ADDRESS_DETAILS, is_defence: e.target.value }) 
                                                }} />
                                        </FormControl>
                                    </div>
                                }
                                <div className="col-md-6 mb-3">
                                    <FormControl fullWidth error={Boolean(errors.email)}>
                                        <div className='label' >Email Address *</div>
                                        <TextField
                                            autoComplete="off"
                                            InputProps={{ sx: { height: '3rem' } }}
                                            value={address?.email}
                                            error={Boolean(errors.email)}
                                            variant="outlined"
                                            onChange={(e) => {
                                                const emailValue = e.target.value.replace(/\s/g, '');
                                                onChange({
                                                    ...address,
                                                    email: emailValue
                                                });
                                                setErrors({
                                                    ...errors,
                                                    email: validateEmail(emailValue)
                                                });
                                            }}
                                            onBlur={(e) => {
                                                setErrors({
                                                    ...errors,
                                                    email: validateEmail(e.target.value)
                                                });
                                            }}
                                        />
                                        {errors.email && (
                                            <FormHelperText sx={{ color: '#ff3333', fontSize: '1rem', textShadow: '0 0 5px rgba(255, 51, 51, 0.8)' }}>
                                                {errors.email}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <FormControl fullWidth error={Boolean(errors.contact_no)}>
                                        <div className='label' >Phone Number *</div>
                                        <TextField
                                            InputProps={{ sx: { height: '3rem' } }}
                                            value={address?.contact_no}
                                            error={Boolean(errors.contact_no)}
                                            variant="outlined"
                                            inputProps={{ maxLength: 10 }}
                                            onChange={(e) => {
                                                const phoneValue = e.target.value.replace(/\s/g, '');
                                                onChange({
                                                    ...address,
                                                    contact_no: phoneValue
                                                });
                                                setErrors({
                                                    ...errors,
                                                    contact_no: validatePhoneNumber(phoneValue)
                                                });
                                            }}
                                            onBlur={(e) => {
                                                setErrors({
                                                    ...errors,
                                                    contact_no: validatePhoneNumber(e.target.value)
                                                });
                                            }}
                                        />
                                        {errors.contact_no && (
                                            <FormHelperText sx={{ color: '#ff3333', fontSize: '1rem', textShadow: '0 0 5px rgba(255, 51, 51, 0.8)' }}>
                                                {errors.contact_no}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </div>

                                {/* <div className="col-md-12 mb-3">
                                    <FormControl fullWidth>
                                        <div className='label' >Address Line *</div>
                                        <TextField variant="outlined"
                                            InputProps={{ sx: { height: '3rem' } }}
                                            value={address?.address_line}
                                            onChange={(e) => {
                                                onChange({
                                                    ...address,
                                                    address_line: e.target.value
                                                })
                                             }} />
                                    </FormControl>
                                </div> */}
                                {/* <div className="col-md-6 mb-3">
                                    <FormControl fullWidth>
                                        <div className='label' >City *</div>
                                        <TextField
                                            variant="outlined"
                                            value={address?.city}
                                            InputProps={{ sx: { height: '3rem' } }} onChange={(e) => {
                                                onChange({
                                                    ...address,
                                                    city: e.target.value
                                                })
                                             }} />
                                    </FormControl>
                                </div> */}
                                <div className="col-md-6 mb-3">
                                    <FormControl fullWidth>
                                        <div className='label' >State *</div>

                                        <Select
                                            style={{ height: '3rem' }}
                                            value={SET_STATE}
                                            onChange={(e) => {
                                                StateHandleChange(e);
                                            }}
                                        >
                                            <MenuItem value={-1} >Select state</MenuItem>
                                            {STATE.map((data, ind) => (
                                                <MenuItem value={ind} key={ind}>{data?.name}</MenuItem>
                                            ))}

                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <FormControl fullWidth>
                                        <div className='label' >Country *</div>
                                        <Select
                                            style={{ height: '3rem' }}
                                            value={address?.country || 'India'}
                                            onChange={(e) => {
                                                onChange({
                                                    ...address,
                                                    country: e.target.value
                                                })
                                            }}
                                        >
                                            <MenuItem value="" disabled>Select country</MenuItem>
                                            {COUNTRY_OPTIONS.map((country, ind) => (
                                                <MenuItem value={country} key={`${country}-${ind}`}>{country}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                {/* <div className="col-md-6 mb-3">
                                    <FormControl fullWidth>
                                        <div className='label' >Pincode/ Zip Code *</div>
                                        <TextField variant="outlined"
                                            InputProps={{ sx: { height: '3rem' } }}
                                            value={address.zip_code}
                                            onChange={(e) => {
                                                onChange({
                                                    ...address,
                                                    zip_code: e.target.value
                                                })
                                             }} />
                                    </FormControl>
                                </div> */}


                            </div>
                        </ThemeProvider>
                    </div>
                </div>



            </div>
        </div>
    );
}

export default AddressForm;
